import React, { useState, useMemo } from 'react';
import './Pages.css';

// Actual laminate design names
const LAMINATE_DESIGNS = [
  "9101 ZR", "9117 ZR", "9118 ZR", "9122 ZR", "9123 ZR", "9143 ZR", "9144 ZR", "9145 ZR",
  "9207 ZR", "9208 ZR", "9209 ZR", "9252 ZR", "9253 ZR", "9402 ZR", "9403 ZR", "9404 ZR",
  "9405 ZR", "9406 ZR", "9407 ZR", "9408 ZR", "9441 ZR", "9446 ZR", "9447 ZR", "9448 ZR",
  "9461 ZR", "9462 ZR", "9463 ZR",
  "9242 CO", "9402 CO", "9403 CO", "9404 CO", "9409 CO", "9446 CO", "9448 CO", "9461 CO",
  "9462 CO", "9463 CO",
  "9410 RX", "9411 RX", "9441 RX", "9443 RX",
  "9242 SF", "9402 SF", "9403 SF", "9405 SF", "9406 SF", "9407 SF", "9441 SF", "9443 SF",
  "9445 SF", "9446 SF", "9447 SF", "9448 SF", "9461 SF",
  "9101 UHG", "9117 UHG", "9118 UHG", "9122 UHG", "9123 UHG", "9143 UHG", "9144 UHG",
  "9145 UHG", "9207 UHG", "9208 UHG", "9209 UHG", "9242 UHG", "9252 UHG", "9253 UHG",
  "9402 UHG", "9403 UHG", "9405 UHG", "9407 UHG", "9444 UHG", "9446 UHG", "9448 UHG",
  "9461 UHG",
  "9242 HZ", "9406 HZ", "9407 HZ", "9448 HZ"
];

function Laminates({ onSelectItem, searchQuery = '' }) {
  const [filters, setFilters] = useState({
    zr: false,
    co: false,
    rx: false,
    sf: false,
    uhg: false,
    hz: false,
  });
  const [filtersOpen, setFiltersOpen] = useState(false);

  const handleFilterChange = (filterName) => {
    setFilters({
      ...filters,
      [filterName]: !filters[filterName]
    });
  };

  const filterOptions = [
    { id: 'zr', label: 'ZR' },
    { id: 'co', label: 'CO' },
    { id: 'rx', label: 'RX' },
    { id: 'sf', label: 'SF' },
    { id: 'uhg', label: 'UHG' },
    { id: 'hz', label: 'HZ' },
  ];

  // Create laminate items from design names
  const laminateItems = useMemo(() => {
    return LAMINATE_DESIGNS.map((name, index) => ({
      id: index + 1,
      name: name,
      type: name.split(' ')[1]?.toLowerCase() || ''
    }));
  }, []);

  // Filter items based on search query and selected filters
  const filteredItems = useMemo(() => {
    let items = laminateItems;

    // Apply search filter
    if (searchQuery) {
      const query = searchQuery.toLowerCase();
      items = items.filter(item => 
        item.name.toLowerCase().includes(query)
      );
    }

    // Apply type filters
    const activeFilters = Object.entries(filters)
      .filter(([_, isActive]) => isActive)
      .map(([type]) => type);

    if (activeFilters.length > 0) {
      items = items.filter(item => activeFilters.includes(item.type));
    }

    return items;
  }, [laminateItems, searchQuery, filters]);

  const activeFiltersCount = Object.values(filters).filter(Boolean).length;

  return (
    <div className="page laminates-page">
      {/* Hero Banner */}
      <div className="page-hero page-hero-small">
        <div className="page-hero-bg laminates-bg"></div>
        <div className="page-hero-content">
          <h1>Our Laminates</h1>
          <p>Discover the perfect finish for your space</p>
        </div>
      </div>

      <div className="laminates-layout">
        <aside className={`filter-sidebar ${filtersOpen ? 'open' : ''}`}>
          <button 
            className="filter-toggle"
            onClick={() => setFiltersOpen(!filtersOpen)}
          >
            <span>Filter by Type</span>
            {activeFiltersCount > 0 && (
              <span className="filter-count">{activeFiltersCount}</span>
            )}
            <span className={`filter-arrow ${filtersOpen ? 'open' : ''}`}>▼</span>
          </button>
          <div className="filter-options">
            {filterOptions.map((option) => (
              <label key={option.id} className="filter-checkbox">
                <input
                  type="checkbox"
                  checked={filters[option.id]}
                  onChange={() => handleFilterChange(option.id)}
                />
                <span className="checkmark"></span>
                {option.label}
              </label>
            ))}
          </div>
        </aside>

        <div className="laminates-content">
          {searchQuery && (
            <p className="search-results-info">
              Showing results for "<strong>{searchQuery}</strong>" ({filteredItems.length} items)
            </p>
          )}
          {!searchQuery && (
            <p className="laminates-intro">
              Explore our collection of decorative laminates for your space
            </p>
          )}
          
          <div className="laminates-grid">
            {filteredItems.length > 0 ? (
              filteredItems.map((item, index) => (
                <div 
                  key={item.id} 
                  className="laminate-card fade-in"
                  style={{ animationDelay: `${Math.min(index * 0.02, 0.5)}s` }}
                  onClick={() => onSelectItem(item)}
                >
                  <div className="laminate-image">
                    <img src="/crunch.png" alt={item.name} className="laminate-img" />
                  </div>
                  <p className="laminate-name">{item.name}</p>
                </div>
              ))
            ) : (
              <p className="no-results">No laminates found matching your criteria</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Laminates;
